export type Feature = { title: string; body: string };

export const FEATURES: Feature[] = [
  {
    title: 'The most comprehensive catalog',
    body: 'Rich metadata for millions of movies, series and episodes — titles, cast, ratings and synopses.',
  },
  {
    title: 'Built for every platform',
    body: 'One API for iOS, Android, desktop and web. Drop it into any app and ship.',
  },
  {
    title: 'Cast, crew & ratings',
    body: 'Directors, writers, full cast, IMDb ratings, awards and release dates for every title.',
  },
  {
    title: 'Partial requests',
    body: 'Ask for exactly the fields you need and look data up by source. Smaller payloads, faster apps.',
  },
  {
    title: 'Multilingual',
    body: 'Localized titles and descriptions across a wide range of languages, out of the box.',
  },
  {
    title: 'Reliable & always current',
    body: 'Continuously updated guide data you can build a business on — commercial use included.',
  },
];
